// extracted by mini-css-extract-plugin
export default {"header-container":"FormLeads_header-container__o7u-L","select-type":"FormLeads_select-type__8hpB9","select-input":"FormLeads_select-input__ICsGY"};